import styled from 'styled-components';
import Image from 'next/image';
import TabComponent from '../../../components/TabComponent';
import {
  CardsWrapper,
} from '../../../components/staking/styles';
import TypeCards from '../../../components/staking/TypeCards';
import BottomStakingComponent from '../../../components/staking/BottomStakingComponent';
import UnclaimedComponent from '../../../components/staking/UnclaimedComponent';

import StakingTopBG from '../../../public/assets/staking/images/staking_desktop_top_bg.webp';
import StakingTopLeftIcon from '../../../public/assets/staking/images/staking_top_left_icon.svg';
import StakingTopRightIcon from '../../../public/assets/staking/images/staking_top_right_icon.svg';
import StakingTopLeftIconMobile from '../../../public/assets/staking/images/staking_top_left_icon_mobile.svg';
import StakingTopRightIconMobile from '../../../public/assets/staking/images/staking_top_right_icon_mobile.svg';
import BigMobilePointHead from "public/assets/header/big_mobile_point_head.svg";
import { nftRarityStaticData } from '../../../components/staking/dummyData';
import StakingBottomBG from '../../../public/assets/staking/images/staking_bottom_background.webp';


const Container = styled.div`
  background: #02161F;
  width: 662px;
  height: 639px;
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    margin-top: 58px;
  }
`
const TopDiv = styled.div`
  color: white;
  height: 229px;
  width: 662px;
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center; /* Ensure items are centered vertically */
  z-index: 2;
  flex-direction: column;
  padding-top: 27px;
  @media (max-width: 768px) {
    width: 100%;
    height:  182px;
    padding-top: 24px;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${StakingTopBG.src});
    background-size: cover;
    background-position: center;
    opacity: 1;
    z-index: 0;
  }
`;

const BottomMidContainerDiv = styled.div`
  width: 100%;
  height: 410px;
  position: relative;
  z-index: 1;
  flex-direction: column;

  @media (max-width: 768px) {
    padding-left: 0px;
    height:  fit-content;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${StakingBottomBG.src});
    background-size: cover;
    background-position: center;
    opacity: 1;
    z-index: 0;
  }
`;
const MidDiv = styled.div`
  padding-left: 10px;
  padding-right: 10px;
`

const StakingTitle = styled.span`
  z-index: 1;
  text-align: center;
  font-family: BPdotsSquares;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 15px */
  letter-spacing: 3.9px;
  text-transform: uppercase;
  background: var(--pissyellow, linear-gradient(91deg, #ADFF00 -9.73%, #FFD600 110.84%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  @media (max-width: 768px) {
    text-align: center;
    font-family: BPdotsSquares;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%; /* 14px */
    letter-spacing: 3.64px;
    text-transform: uppercase;
  }
`;

const IconContainer = styled.div`
  z-index: 1; /* Ensure icons are above the background */
  @media (max-width: 768px) {
    display: none;
  }
`;

const IconContainerMobile = styled.div`
  z-index: 1; /* Ensure icons are above the background */
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;
interface YourPointsDivProps {
  width?: string;
  height?: string;
}

export const YourPointsDiv = styled.div<YourPointsDivProps>`
  width: ${(props) => props.width || '113.05px'};
  height: ${(props) => props.height || '19.85px'};
  box-sizing: border-box;
  border: 1px solid transparent; /* Transparent border to maintain spacing */
  background: transparent; /* Transparent background */
  z-index: 1; /* Adjust z-index as needed */
  position: relative; /* Ensure pseudo-element is positioned relative to this */
  /* Apply border-image for gradient effect */
  border-image: linear-gradient(91.45deg, #ADFF00 -9.73%, #FFD600 110.84%) 1; /* 1 is the border width */

  /* Ensure content doesn't overflow */
  overflow: hidden;
  margin-bottom: -1px;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  align-items: center;
  border-bottom: none;
  @media (max-width: 768px) {
    width: 135.05px;
    height: 23.85px;
    margin-top: 19px;
  }
`;

const YourPointsSpan = styled.span`
  background: linear-gradient(91.45deg, #ADFF00 -9.73%, #FFD600 110.84%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  text-align: center;
  font-family: BPdotsUnicaseSquare;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 13px */
  letter-spacing: 2.08px;
  text-transform: uppercase;
  @media (max-width: 768px) {
    text-align: center;
    font-family: BPdotsUnicaseSquare;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%; /* 12px */
    letter-spacing: 1.92px;
    text-transform: uppercase;
  }
`

const PointsContainer = styled.div`
  position: relative;
  width: 345px; /* Adjust width as per your image dimensions */
  height: 45px; /* Adjust height as per your image dimensions */
  background-image: url(${BigMobilePointHead.src});
  background-size: cover; /* Adjust as needed */
  background-position: center; /* Adjust as needed */
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff; /* Text color */
  font-size: 18px; /* Adjust font size */
  font-weight: bold; /* Adjust font weight */
  @media (max-width: 768px) {
    width: 307px;
    height: 40px;
  }
`;

const PointsText = styled.div`
  position: absolute;
  top: 55%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  color: #fff; /* Text color */
  font-size: 18px; /* Adjust font size */
  font-weight: bold; /* Adjust font weight */
  text-align: center;
  font-family: BPdotsUnicaseSquare;
  font-size: 31.577px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 31.577px */
  text-transform: uppercase;
  background: var(--pissyellow, linear-gradient(91deg, #ADFF00 -9.73%, #FFD600 110.84%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  @media (max-width: 768px) {
    text-align: center;
    font-family: BPdotsUnicaseSquare;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%; /* 28px */
    text-transform: uppercase;
  }
`;

const SmallBoxTitleSpan = styled.span`
  font-family: BPdotsSquares;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 13px */
  letter-spacing: 3.38px;
  text-transform: uppercase;
  opacity: 0.8;
  background: var(--pissyellow, linear-gradient(91deg, #ADFF00 -9.73%, #FFD600 110.84%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  @media (max-width: 768px) {
    font-family: BPdotsSquares;
    font-size: 8px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%; /* 8px */
    letter-spacing: 2.08px;
    text-transform: uppercase;
  }
`;

const SmallBoxValueSpan = styled.span`
  font-family: BPdotsUnicaseSquare;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 16px */
  letter-spacing: 1.28px;
  text-transform: uppercase;
  background: var(--pissyellow, linear-gradient(91deg, #ADFF00 -9.73%, #FFD600 110.84%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  @media (max-width: 768px) {
    font-family: BPdotsUnicaseSquare;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%; /* 12px */
    letter-spacing: 0.96px;
    text-transform: uppercase;
  }
`;

export default function StakingComponent({ 
  appState, dashboardData, isLoading, isMobile,
  setAppState, refreshRequired, isConnected, refetch
}:any) {
  // const token =
  //   typeof window !== 'undefined' ? localStorage.getItem('token') : undefined;

  // const [setDashboardData,setIsLoading] = useStakingStore(useShallow((s) => [
  //   s.setDashboardData,s.setIsLoading]));
  // const { data, isLoading } = useDashboard(isConnected, token, refreshRequired);
  // const queryClient = useQueryClient();
  // const dashboardData = data?.data as XNetDashboard;
  let boost = 0;
  

  if (dashboardData?.staking?.boosts) {
    dashboardData?.staking.boosts.map((b) => {
      boost += b.totalPointBoost;
    })  
  }
  const token =
    typeof window !== 'undefined' ? localStorage.getItem('token') : undefined;

  const isUnclaimedNft = dashboardData?.nfts?.filter(
    (nft) => !nft.claimed
  )?.length;

  

  if (isUnclaimedNft) {
    return (
      <UnclaimedComponent
        dashboardData={dashboardData}
        appState={appState}
        token={token}
        refreshRequired={refreshRequired}
        setAppState={setAppState}
        isConnected={isConnected}
        refetch={refetch}
        // isConnected={isConnected}
        // token={token}
        // refreshRequired={refreshRequired}
        // setAppState={setAppState}
        >
    </UnclaimedComponent>
    );
  }


  return (
    <Container>
      <TopDiv>
        <div style={{
          position: "relative",
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}>
          <IconContainer>
            <Image src={StakingTopLeftIcon} alt="Left Icon" />
          </IconContainer>
          <IconContainerMobile>
            <Image src={StakingTopLeftIconMobile} alt="Left Icon" />
          </IconContainerMobile>
          <StakingTitle>Staking</StakingTitle>
          <IconContainer>
            <Image src={StakingTopRightIcon} alt="Right Icon" />
          </IconContainer>
          <IconContainerMobile>
            <Image src={StakingTopRightIconMobile} alt="Left Icon" />
          </IconContainerMobile>
        </div>
        <div style={{
          display: "flex",
          position: "relative",
          zIndex: 1,
          width: "100%", alignItems: "center", justifyContent: "center",
          flexDirection: "column",
        }}>
          <YourPointsDiv width='144.05px' height='25.85px'>
            <YourPointsSpan>your points</YourPointsSpan>
          </YourPointsDiv>
          <PointsContainer>
            <PointsText>{dashboardData?.xnetPoints ? dashboardData?.xnetPoints.toFixed(3):0} PTS</PointsText>
            {/* <PointsText>{dashboardData?.xnetPoints} PTS</PointsText> */}
          </PointsContainer>
        </div>
        <div style={{
          position: "absolute",
          display: "flex",
          justifyContent: "space-between",
          left: 0,
          width: "100%",
          bottom: isMobile?-20:-30,
        }}>
          <TabComponent width={"276px"} height={"60px"}
            mobileHeight={'42px'} mobileWidth={'159px'}
            cutColor='#02161F'
            showBorder={true}
            strokeColor='#5B5E14'
            background={'linear-gradient(to top, #071517, #0F1D16);'}
            parentStyle={{ marginLeft: isMobile?7:40 }}
            style={{ paddingLeft: 15, 
              paddingRight: 10,
              display:"flex",
              flexDirection:"column",
              justifyContent:"center",
              alignItems:"flex-start"
            }}
            isStaking={true}
          >
            <SmallBoxTitleSpan>$XTREME POINTS RATE</SmallBoxTitleSpan>
            <SmallBoxValueSpan>{dashboardData?.staking?.pointsPerHour? dashboardData?.staking?.pointsPerHour: 0} pts / hr</SmallBoxValueSpan>
          </TabComponent>
          <TabComponent width={"276px"} height={"60px"}
            mobileHeight={'42px'} mobileWidth={'159px'}
            cutColor='#02161F'
            showBorder={true}
            strokeColor='#5B5E14'
            background={'linear-gradient(to top, #071517, #0F1D16);'}
            parentStyle={{ marginRight: isMobile?7:40 }}
            style={{ paddingLeft: 15, 
              paddingRight: 10,
              display:"flex",
              flexDirection:"column",
              justifyContent:"center",
              alignItems:"flex-start"
            }}
            isStaking={true}
          >
            <SmallBoxTitleSpan>nft rarity bonus</SmallBoxTitleSpan>
            <SmallBoxValueSpan>{boost} pts / hr</SmallBoxValueSpan>
          </TabComponent>
        </div>
      </TopDiv>
      <BottomMidContainerDiv>
      <MidDiv>
        <CardsWrapper className="stake">
          {nftRarityStaticData.map((rarityData, index) => {
            const nftObj = dashboardData?.nfts?.filter(
              (nft) => nft.rarity === rarityData
            )?.[0];
            const boostObj =
              dashboardData?.staking?.boosts?.filter(
                (boostObj) => boostObj.nftRarity === rarityData
              )?.[0];
            // @ts-ignore
            return (
              <TypeCards
                nft={{
                  ...nftObj,
                  ...boostObj,
                  nftRarity: rarityData,
                }}
                key={index}
                nftStatus={appState.stakeState}
                tab={appState.subTabName as any}
                loading={isLoading}
              />
            );
          })}
        </CardsWrapper>
      </MidDiv>
      <BottomStakingComponent
        key={dashboardData?.xnetBalance}
        isConnected={isConnected}
        appState={appState}
        dashboardData={dashboardData}
        isLoading={isLoading}
        isMobile={isMobile}
        xnetBalance={dashboardData?.xnetBalance}
      ></BottomStakingComponent>
      </BottomMidContainerDiv>
    </Container>
  );
}
export async function getServerSideProps(context) {
  return {
    props: {}, // will be passed to the page component as props
  }
}